import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApiCallHandler, EoHttpClient, IHttpParams } from 'ngx-eo-web-components';
import { BehaviorSubject, Subject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { STATUS } from '../../modules/core/models/loading-status.enum';
import {
  IToken,
  LoginResponse,
} from '../../modules/core/models/token-response.model';
import { jwtDecode } from 'jwt-decode';
import { CoreService } from '../../modules/core/core.service';

@Injectable({
  providedIn: 'root',
})
export class GsisOAuth2Service {
  constructor(private http: EoHttpClient, private coreService: CoreService) {}

  public loginCallHandler  =  new ApiCallHandler<any | null>();

  init() {
    this.loginCallHandler.init(null);
  }

  fetchToken(username: string, amka: string, token: string) {
    
    const params: IHttpParams = this.coreService.initCall(
      `/v1/GsisOAuth/extlogin`,
      this.loginCallHandler,
      {
        Username: username,
        Amka: amka, 
        ExternalAccessToken: token
      }
    );

    return this.http.post<LoginResponse>(params);
  }
 
}
